module.exports = __webpack_public_path__ + "static/media/icon-piece-smart-watch-02.1ff0b6ff.png";